<template>
  <div v-bind="$attrs" v-if="$attrs.isLoading" class="my-8"  >
    <v-row class="align-center mb-4">
      <v-skeleton-loader type="button" width="50" class="mx-0"> </v-skeleton-loader>
      <v-skeleton-loader width="150" class="mx-6" type="text"> </v-skeleton-loader>
      <v-skeleton-loader type="button" width="50" class="mx-0"> </v-skeleton-loader>
    </v-row>
    <v-row :key="id" v-for="(skeleton,id) in 4" class="justify-start my-2">
      <v-skeleton-loader class="d-flex justify-space-between" width="300" type="avatar@5"> </v-skeleton-loader>
    </v-row>
    <v-row class="justify-end my-2 mx-4" style="width:300px" >
      <v-skeleton-loader width="150"  class="d-flex mr-8 my-5 justify-space-between" type="button@2"> </v-skeleton-loader>
    </v-row>
  </div>
  <div v-else>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="fade-transition"
      offset-y
      min-width="300px"
      :return-value.sync="Value"
      v-if="$attrs.popup == true || $attrs.popup === ''"
    >
      <template v-slot:activator="{ on }">
        <edn-field
          :ename="$attrs.ename"
          :id="$attrs.id"
          :disabled="$attrs.disabled || getIrisRdonlyMode"
          :filled="getIrisRdonlyMode"
          :label="$attrs.label"
          v-model="getFormattedDate"
          v-on="on"
          :rules="rules"
          :placeholder="$attrs.placeholder"
          :append-icon="getAppendedIcon"
          v-bind="$attrs"
        ></edn-field>
      </template>
      <v-date-picker
        :ename="$attrs.ename"
        :id="$attrs.id"
        :color="colors.primary"
        no-title
        scrollable
        v-bind="$attrs"
        v-model="Value"
       @change="changeDate($event)"
        :locale="getDateLocale"
        :min="min"
        :first-day-of-week="1"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Annuler</v-btn>
        <v-btn text color="primary" @click="$refs.menu.save(Value)">OK</v-btn>
      </v-date-picker>
    </v-menu>
    <v-date-picker
      v-else
      :color="colors.primary"
      no-title
      scrollable
      v-bind="$attrs"
      v-model="Value"
      :locale="getDateLocale"
      :min="min"
      :first-day-of-week="1"
      :class="$attrs.tripStyle"
      @change="changeDate($event)"
    ></v-date-picker>
  </div>
</template>
<script>

import { ednRequired } from './mixins/ednRequired';
import { format as fnsFormat, parseISO as fnsParseISO, isValid as fnsIsValid, parse as fnsParse } from 'date-fns';
import { ednMimicMix } from './mixins/ednMimicMix';
import { ednValue } from './mixins/ednValue';

export default {
  inheritAttrs: false,
  mixins: [ednRequired, ednMimicMix, ednValue],
  props: {
    format: {
      type: String,
      default: () => 'dd-MM-yyyy',
    },
    min: {
      type: String,
      default: () => null,
    },
    value: null,
  },
  data() {
    return {
      menu: null,
      colors: {
        primary: this.$vuetify.theme.currentTheme.primary,
        secondary: this.$vuetify.theme.currentTheme.secondary,
      }
    }
  },
  computed: {
    getFormattedDate: {
      get() {
        if (this.value) {
          return fnsFormat(fnsParseISO(this.value), this.format)
        }else{
          return ''
        }
      },
      set(value) {
        if (value !== '') {
          return value
        } else {
          return ''
        }
      },
    },
    /**
     * Renvoie la langue de la date, par défaut en fr
     */
    getDateLocale(){
      return this.$attrs.locale || 'fr';
    }
  },
  created() {
    this.$vuetify.theme.currentTheme.primary
  },
  methods:{
    changeDate(e){
        this.$emit("changeDate",e)
    }
  }
}
</script>
<style lang="scss">
div {
	&.tripStyle {
		div {
			&.v-date-picker-header {
				background-color: #fafafa;
			}
			&.v-date-picker-table {
				background-color: #fafafa;
				height: 275px;
				th {
					color: #000;
				}
				button {
					&.v-btn {
						background-color: #fff;
						transition: all 0.3s;
						box-shadow: 0 1px 0 0 #c5c5ca;
						margin: 2px;
						border-radius: 0.4em;
						&.v-btn--disabled {
							background-color: transparent;
							box-shadow: none;
						}
						&.v-date-picker-table__current {
							border: none;
							box-shadow: 0 1px 0 0 var(--v-primary-lighten1), inset 0 -1px 0 0 var(--v-primary-base);
						}
						&:hover {
							margin-top: -1px;
							box-shadow: 0 1px 0 0 #c5c5ca, inset 0 -1px 0 0 #4e4e56;
							&::before {
								opacity: 0;
							}
						}
					}
				}
			}
		}
	}
}

</style>